/** Naive local-date string helpers for the weekly rota — mirrors backend/src/modules/slighter-crm/staff/shift-time.util.ts's date maths (frontend only needs the calendar parts, not the overnight-shift-hours maths). */

const pad2 = (n: number) => String(n).padStart(2, '0');

export const ymdLocal = (d: Date): string => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

export const addDaysStr = (ymd: string, days: number): string => {
  const d = new Date(`${ymd}T00:00:00`);
  d.setDate(d.getDate() + days);
  return ymdLocal(d);
};

/** Monday of the week containing `ymd` (Monday-start week, matching the backend). */
export const mondayOfStr = (ymd: string): string => {
  const dow = new Date(`${ymd}T00:00:00`).getDay(); // 0=Sun..6=Sat
  return addDaysStr(ymd, dow === 0 ? -6 : 1 - dow);
};

export const weekDaysOf = (weekStart: string): string[] => Array.from({ length: 7 }, (_, i) => addDaysStr(weekStart, i));

export const formatDayLabel = (ymd: string): string =>
  new Date(`${ymd}T00:00:00`).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });

export const formatDayShort = (ymd: string): { weekday: string; day: string } => {
  const d = new Date(`${ymd}T00:00:00`);
  return { weekday: d.toLocaleDateString(undefined, { weekday: 'short' }), day: d.toLocaleDateString(undefined, { day: 'numeric', month: 'short' }) };
};

export const formatWeekRange = (weekStart: string, weekEnd: string): string => {
  const s = new Date(`${weekStart}T00:00:00`);
  const e = new Date(`${weekEnd}T00:00:00`);
  const sameMonth = s.getMonth() === e.getMonth() && s.getFullYear() === e.getFullYear();
  const startLabel = s.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  // A bare {day, year} format renders as "2026 (day: 27)" in some locales, so the year is appended by hand.
  const endLabel = sameMonth ? String(e.getDate()) : e.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  return `${startLabel} – ${endLabel}, ${e.getFullYear()}`;
};

export const isToday = (ymd: string): boolean => ymd === ymdLocal(new Date());
